import { Dialog, DialogContent } from '@eigtech/ui/components/dialog'
import { MediaCarousel, MediaCarouselProps } from './MediaCarousel'

export type MediaCarouselModalProps = MediaCarouselProps & {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function MediaCarouselModal({ open, onOpenChange, ...props }: MediaCarouselModalProps) {
  if (!open) return null

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="media-carousel-modal max-h-full min-h-0 sm:max-w-6xl"
        data-initial-document-id={props.initialDocument?.id}
      >
        <MediaCarousel
          className="mx-10 mt-6 max-h-[calc(100vh-25rem)] w-full max-w-[calc(100vh-25rem)]"
          {...props}
        />
      </DialogContent>
    </Dialog>
  )
}
